// Shimmer.js
import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

// Keyframes for shimmer animation
const shimmerKeyframe = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

// Shimmer effect container
const ShimmerEffect = styled.div`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "20px"};
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1000px 104px;
  animation: ${shimmerKeyframe} 1.2s infinite linear;
  border-radius: 4px;
  margin-bottom: 10px;
`;

// Shimmer wrapper for organizing multiple shimmer elements
const ShimmerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ShimmerRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

// Specific shimmer elements for different types of placeholders
const ShimmerBadge = styled(ShimmerEffect)`
  width: 160px;
  height: 35px;
`;

const ShimmerDropdown = styled(ShimmerEffect)`
  width: 160px;
  height: 34px;
`;

const ShimmerTextInput = styled(ShimmerEffect)`
  height: 40px;
`;

const ShimmerAvatar = styled(ShimmerEffect)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

// Exporting shimmer elements
export {
  ShimmerEffect,
  ShimmerContainer,
  ShimmerRow,
  ShimmerBadge,
  ShimmerDropdown,
  ShimmerTextInput,
  ShimmerAvatar,
};
